import { Icon } from "@/components/icon";
import { Image } from "@/components/image";
import { DialogOverlay } from "@/components/ui/dialog";
import { Dialog } from "radix-ui";

export function ImageFullscreen({ src }: { src: string }) {
	return (
		<Dialog.Portal>
			<DialogOverlay />
			<Dialog.Content className="flex items-center justify-center data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 translate-x-[-50%] translate-y-[-50%]">
				<Image
					src={src}
					quality={100}
					className="max-w-[cal(100dvw-1.5rem)] max-h-[calc(100dvh-1.5rem)] size-full lg:max-w-[1000px] md:max-h-[1200px]"
				/>
			</Dialog.Content>

			<Dialog.Close className="z-50 absolute top-4 rounded right-4 size-8 flex items-center justify-center hover:bg-muted">
				<Icon name="X" className="size-6 text-white" />
			</Dialog.Close>
		</Dialog.Portal>
	);
}
